var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Sportsbook } from "../contracts";
import { observable, action } from "mobx";
/* istanbul ignore file */
// TODO: test with decorator mock when correct approach is found
let SportConnection = class SportConnection {
    constructor(blockUniqueId) {
        this.sportResponse = {};
        this.meta = { requesterId: blockUniqueId };
    }
    deactivate() {
        this.query = undefined;
    }
    onData(payload) {
        this.sportResponse = payload;
    }
    onError(error) {
        this.error = error;
    }
    updateQuery(eventIds, marketTypeRequests) {
        this.query = Sportsbook.queryBuilder.getEventsByEventId({ ids: eventIds, includeFields: ["Events", "Markets"], marketTypeRequests });
    }
};
__decorate([
    observable,
    __metadata("design:type", Object)
], SportConnection.prototype, "error", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SportConnection.prototype, "sportResponse", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SportConnection.prototype, "onData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SportConnection.prototype, "onError", null);
SportConnection = __decorate([
    Sportsbook.connection(),
    __metadata("design:paramtypes", [String])
], SportConnection);
export { SportConnection };
//# sourceMappingURL=SportConnection.js.map